module.exports = __webpack_public_path__ + "static/img/bg_theme_blue2@2x.9cf73b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/skin/bg_theme_blue2@2x.png
// module id = s7o0
// module chunks = 1